import { FilterQueryType } from "cloud-core/filters/FilterSet";
import { AnalyticsStateView } from "../../../store/analytics/Analytics";
import { Entity } from "../Entity";

export abstract class EntityFilter {
    displayName: string;
    filterRef: string;
    type: FilterQueryType;
    defaultParams: unknown = undefined;

    constructor(displayName: string, filterRef: string) {
        this.displayName = displayName;
        this.filterRef = filterRef;
    }

    abstract predicate(entities: Entity[], parameter: unknown): Entity[];
    abstract createComponent(filterId: string, view: AnalyticsStateView, options?: unknown): JSX.Element;
    abstract createParameterObject(parameter: unknown): unknown;
    abstract parseParameterObject(parameterObject: unknown): unknown;

    withDefaultParams(defaultParams: unknown): this {
        this.defaultParams = defaultParams;
        return this;
    }
}
